var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information-field"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.text)+" ")])]),_c('Dots',{attrs:{"width":7,"height":6,"top":false,"left":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }